import enAmountReceivable from '@components/amount-receivable/locales/en.json'
import esAmountReceivable from '@components/amount-receivable/locales/es.json'
import ptAmountReceivable from '@components/amount-receivable/locales/pt.json'
import enHeading from '@components/amounts-received/components/heading/locales/en.json'
import esHeading from '@components/amounts-received/components/heading/locales/es.json'
import ptHeading from '@components/amounts-received/components/heading/locales/pt.json'
import enAmounts from '@components/amounts-received/locales/en.json'
import esAmounts from '@components/amounts-received/locales/es.json'
import ptAmounts from '@components/amounts-received/locales/pt.json'
import enCardNfData from '@components/card-nf-data/locales/en.json'
import esCardNfData from '@components/card-nf-data/locales/es.json'
import ptCardNfData from '@components/card-nf-data/locales/pt.json'
import enCardPaymentData from '@components/card-payment-data/locales/en.json'
import esCardPaymentData from '@components/card-payment-data/locales/es.json'
import ptCardPaymentData from '@components/card-payment-data/locales/pt.json'
import enHistoryValue from '@components/history-value/locales/en.json'
import esHistoryValue from '@components/history-value/locales/es.json'
import ptHistoryValue from '@components/history-value/locales/pt.json'
import enIncomeReport from '@components/income-report/locales/en.json'
import esIncomeReport from '@components/income-report/locales/es.json'
import ptIncomeReport from '@components/income-report/locales/pt.json'
import enInputDocumentCnpj from '@components/inputs/input-document-cnpj/locales/en.json'
import esInputDocumentCnpj from '@components/inputs/input-document-cnpj/locales/es.json'
import ptInputDocumentCnpj from '@components/inputs/input-document-cnpj/locales/pt.json'
import enInputDocumentRg from '@components/inputs/input-document-rg/locales/en.json'
import esInputDocumentRg from '@components/inputs/input-document-rg/locales/es.json'
import ptInputDocumentRg from '@components/inputs/input-document-rg/locales/pt.json'
import enInternationaPayment from '@components/international-payment/locales/en.json'
import esInternationaPayment from '@components/international-payment/locales/es.json'
import ptInternationaPayment from '@components/international-payment/locales/pt.json'
import enModalAcceptAntecipation from '@components/modals/modal-accept-antecipation/locales/en.json'
import esModalAcceptAntecipation from '@components/modals/modal-accept-antecipation/locales/es.json'
import ptModalAcceptAntecipation from '@components/modals/modal-accept-antecipation/locales/pt.json'
import enModalAntecipationOnboarding from '@components/modals/modal-antecipation-onboarding/locales/en.json'
import esModalAntecipationOnboarding from '@components/modals/modal-antecipation-onboarding/locales/es.json'
import ptModalAntecipationOnboarding from '@components/modals/modal-antecipation-onboarding/locales/pt.json'
import enModalNfeConnection from '@components/modals/modal-nfe-connection/locales/en.json'
import esModalNfeConnection from '@components/modals/modal-nfe-connection/locales/es.json'
import ptModalNfeConnection from '@components/modals/modal-nfe-connection/locales/pt.json'
import enModalPaymentErrors from '@components/modals/modal-payment-errors/locales/en.json'
import esModalPaymentErrors from '@components/modals/modal-payment-errors/locales/es.json'
import ptModalPaymentErrors from '@components/modals/modal-payment-errors/locales/pt.json'
import enModalPaymentOnboarding from '@components/modals/modal-payment-onboarding/locales/en.json'
import esModalPaymentOnboarding from '@components/modals/modal-payment-onboarding/locales/es.json'
import ptModalPaymentOnboarding from '@components/modals/modal-payment-onboarding/locales/pt.json'
import enModalPopupAntecipation from '@components/modals/modal-popup-antecipation/locales/en.json'
import esModalPopupAntecipation from '@components/modals/modal-popup-antecipation/locales/es.json'
import ptModalPopupAntecipation from '@components/modals/modal-popup-antecipation/locales/pt.json'
import enModalSendNf from '@components/modals/modal-send-nf/locales/en.json'
import esModalSendNf from '@components/modals/modal-send-nf/locales/es.json'
import ptModalSendNf from '@components/modals/modal-send-nf/locales/pt.json'
import enUploadInvoice from '@components/upload-invoice/locales/en.json'
import esUploadInvoice from '@components/upload-invoice/locales/es.json'
import ptUploadInvoice from '@components/upload-invoice/locales/pt.json'
import enFormPaymentNf from '@pages/payments-data/components/form-payment-nf/locales/en.json'
import esFormPaymentNf from '@pages/payments-data/components/form-payment-nf/locales/es.json'
import ptFormPaymentNf from '@pages/payments-data/components/form-payment-nf/locales/pt.json'
import enFormReceiveBank from '@pages/payments-data/components/form-receive-bank/locales/en.json'
import esFormReceiveBank from '@pages/payments-data/components/form-receive-bank/locales/es.json'
import ptFormReceiveBank from '@pages/payments-data/components/form-receive-bank/locales/pt.json'
import enPaymentsData from '@pages/payments-data/locales/en.json'
import esPaymentsData from '@pages/payments-data/locales/es.json'
import ptPaymentsData from '@pages/payments-data/locales/pt.json'
import enExtract from '@pages/payments-details/components/extract/locales/en.json'
import esExtract from '@pages/payments-details/components/extract/locales/es.json'
import ptExtract from '@pages/payments-details/components/extract/locales/pt.json'
import enPaymentsHistory from '@pages/payments-history/locales/en.json'
import esPaymentsHistory from '@pages/payments-history/locales/es.json'
import ptPaymentsHistory from '@pages/payments-history/locales/pt.json'
import enPaymentsInfo from '@pages/payments-info/locales/en.json'
import esPaymentsInfo from '@pages/payments-info/locales/es.json'
import ptPaymentsInfo from '@pages/payments-info/locales/pt.json'
import enInputRecordEmployment from '@src/components/inputs/input-record-employment/locales/en.json'
import esInputRecordEmployment from '@src/components/inputs/input-record-employment/locales/es.json'
import ptInputRecordEmployment from '@src/components/inputs/input-record-employment/locales/pt.json'
import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import enGlobal from './assets/locales/en.json'
import esGlobal from './assets/locales/es.json'
import ptGlobal from './assets/locales/pt.json'
import enCardXmlData from './components/card-xml-data/locales/en.json'
import esCardXmlData from './components/card-xml-data/locales/es.json'
import ptCardXmlData from './components/card-xml-data/locales/pt.json'
import enTransactionDetails from './components/transaction-details/locales/en.json'
import esTransactionDetails from './components/transaction-details/locales/es.json'
import ptTransactionDetails from './components/transaction-details/locales/pt.json'
import enTransferReceipt from './components/transfer-receipt/locales/en.json'
import esTransferReceipt from './components/transfer-receipt/locales/es.json'
import ptTransferReceipt from './components/transfer-receipt/locales/pt.json'

export const defaultNS = 'globalPayments'
export const resources = {
  en: {
    globalPayments: enGlobal,
    paymentsData: enPaymentsData,
    inputRecordEmployment: enInputRecordEmployment,
    inputDocumentRg: enInputDocumentRg,
    paymentFormReceiveBank: enFormReceiveBank,
    internationalPayment: enInternationaPayment,
    inputDocumentCnpj: enInputDocumentCnpj,
    formPaymentNf: enFormPaymentNf,
    cardPaymentData: enCardPaymentData,
    modalPaymentOnboarding: enModalPaymentOnboarding,
    cardNfData: enCardNfData,
    modalPaymentErrors: enModalPaymentErrors,
    historyValue: enHistoryValue,
    amounts: enAmounts,
    amountReceivable: enAmountReceivable,
    paymentsInfo: enPaymentsInfo,
    paymentsHistory: enPaymentsHistory,
    uploadInvoice: enUploadInvoice,
    incomeReport: enIncomeReport,
    extract: enExtract,
    transferReceipt: enTransferReceipt,
    cardXmlData: enCardXmlData,
    modalNfeConnection: enModalNfeConnection,
    modalAntecipationOnboarding: enModalAntecipationOnboarding,
    modalSendNf: enModalSendNf,
    modalAcceptAntecipation: enModalAcceptAntecipation,
    modalPopupAntecipation: enModalPopupAntecipation,
    heading: enHeading,
    transactionDetails: enTransactionDetails,
  },
  pt: {
    globalPayments: ptGlobal,
    paymentsData: ptPaymentsData,
    inputRecordEmployment: ptInputRecordEmployment,
    inputDocumentRg: ptInputDocumentRg,
    paymentFormReceiveBank: ptFormReceiveBank,
    internationalPayment: ptInternationaPayment,
    inputDocumentCnpj: ptInputDocumentCnpj,
    formPaymentNf: ptFormPaymentNf,
    cardPaymentData: ptCardPaymentData,
    modalPaymentOnboarding: ptModalPaymentOnboarding,
    cardNfData: ptCardNfData,
    modalPaymentErrors: ptModalPaymentErrors,
    historyValue: ptHistoryValue,
    amounts: ptAmounts,
    amountReceivable: ptAmountReceivable,
    paymentsInfo: ptPaymentsInfo,
    paymentsHistory: ptPaymentsHistory,
    uploadInvoice: ptUploadInvoice,
    incomeReport: ptIncomeReport,
    extract: ptExtract,
    transferReceipt: ptTransferReceipt,
    cardXmlData: ptCardXmlData,
    modalNfeConnection: ptModalNfeConnection,
    modalAntecipationOnboarding: ptModalAntecipationOnboarding,
    modalSendNf: ptModalSendNf,
    modalAcceptAntecipation: ptModalAcceptAntecipation,
    modalPopupAntecipation: ptModalPopupAntecipation,
    heading: ptHeading,
    transactionDetails: ptTransactionDetails,
  },
  es: {
    globalPayments: esGlobal,
    paymentsData: esPaymentsData,
    inputRecordEmployment: esInputRecordEmployment,
    inputDocumentRg: esInputDocumentRg,
    paymentFormReceiveBank: esFormReceiveBank,
    internationalPayment: esInternationaPayment,
    inputDocumentCnpj: esInputDocumentCnpj,
    formPaymentNf: esFormPaymentNf,
    cardPaymentData: esCardPaymentData,
    modalPaymentOnboarding: esModalPaymentOnboarding,
    cardNfData: esCardNfData,
    modalPaymentErrors: esModalPaymentErrors,
    historyValue: esHistoryValue,
    amounts: esAmounts,
    amountReceivable: esAmountReceivable,
    paymentsInfo: esPaymentsInfo,
    paymentsHistory: esPaymentsHistory,
    uploadInvoice: esUploadInvoice,
    incomeReport: esIncomeReport,
    extract: esExtract,
    transferReceipt: esTransferReceipt,
    cardXmlData: esCardXmlData,
    modalNfeConnection: esModalNfeConnection,
    modalAntecipationOnboarding: esModalAntecipationOnboarding,
    modalSendNf: esModalSendNf,
    modalAcceptAntecipation: esModalAcceptAntecipation,
    modalPopupAntecipation: esModalPopupAntecipation,
    heading: esHeading,
    transactionDetails: esTransactionDetails,
  },
} as const

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    defaultNS,
    ns: [
      'globalPayments',
      'paymentsData',
      'inputRecordEmployment',
      'inputDocumentRg',
      'paymentFormReceipt',
      'paymentFormReceiveBank',
      'internationalPayment',
      'inputDocumentCnpj',
      'formPaymentNf',
      'cardPaymentData',
      'modalPaymentOnboarding',
      'cardNfData',
      'modalPaymentErrors',
      'historyValue',
      'cardPaymentValue',
      'amounts',
      'paymentStatus',
      'amountReceivable',
      'paymentsInfo',
      'paymentsHistory',
      'uploadInvoice',
      'incomeReport',
      'extract',
      'transferReceipt',
      'modalUnblockPayment',
      'cardXmlData',
      'modalNfeConnection',
      'modalAntecipationOnboarding',
      'modalSendNf',
      'modalAcceptAntecipation',
      'modalPopupAntecipation',
      'heading',
      'transactionDetails',
    ],
    load: 'all',
    supportedLngs: ['en', 'es', 'pt'],
    lng: navigator.language?.split('-')[0] || 'en',
    fallbackLng: 'en',
    debug: false,
    cache: {
      enabled: false,
    },
    resources,
  })

export default i18n
